import { useContext } from 'react';
import { Button } from '@unified-checkout/design-system';
import {
  ArrowLeft,
  ChevronLeft,
} from '@unified-checkout/design-system/icons/index';
import { DeviceContext } from '../../context/device';

type BackButtonProps = {
  onClick: () => void;
};
export const BackButton = ({ onClick }: BackButtonProps) => {
  const { isMobile } = useContext(DeviceContext);
  return (
    <div className="mb-4 md:mb-8 [&_button]:md:ps-0">
      {isMobile ? (
        <Button
          size="md"
          text=""
          leadingIcon={ChevronLeft}
          variant="outlined"
          color="secondary"
          onClickHandler={onClick}
        />
      ) : (
        <Button
          text="Back"
          leadingIcon={ArrowLeft}
          onClickHandler={onClick}
          color="secondary"
          size="sm"
          variant="link"
        />
      )}
    </div>
  );
};
